module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAALCAYAAAByF90EAAAAAXNSR0IArs4c6QAAAIZJREFUKBWdkNEJwCAMRJ3FL3+7QCdwLXdwyQ7Qr/SuJCCWmrQHR0TvHpiUHInIRjux9bNCDkz6H2yA4HjrOww1fodF6lTzHIchPEMq7mgCKR+G0ANiW8RbDLaChGERiAsDpMDjYquV3iby8zdLwmWDKS7ThRicWe1gSCMowx3eLRSd7Gg3X1B3MVx3HrK6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/IsraelToday/path.png
// module id = hlKe
// module chunks = 0